import { ENV_SERVICE_URLS } from "../../config/environment"

export const getPurchaseServiceURL = (region = ""): string =>
  ENV_SERVICE_URLS[region] ?? ENV_SERVICE_URLS.default ?? ""
